var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.125C4 9.39896 5.39896 8 7.125 8H25.875C27.601 8 29 9.39896 29 11.125V23.625C29 25.351 27.601 26.75 25.875 26.75H7.125C5.39896 26.75 4 25.351 4 23.625V11.125ZM7.12509 10.0837C6.55009 10.0837 6.08342 10.5504 6.08342 11.1254V12.167H26.9168V11.1254C26.9168 10.5504 26.4501 10.0837 25.8751 10.0837H7.12509ZM26.9168 14.25H6.08342V23.625C6.08342 24.2 6.55009 24.6667 7.12509 24.6667H25.8751C26.4501 24.6667 26.9168 24.2 26.9168 23.625V14.25ZM8.16658 21.5417C8.16658 20.9667 8.63324 20.5 9.20824 20.5H15.4582C16.0332 20.5 16.4999 20.9667 16.4999 21.5417C16.4999 22.1167 16.0332 22.5833 15.4582 22.5833H9.20824C8.63324 22.5833 8.16658 22.1167 8.16658 21.5417V21.5417Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/DefaultCard.53fd67e3b95e7d7d0b8e7bb43e66c7d2.svg";
export { ForwardRef as ReactComponent };